import {
    Cross2Icon,
    UpdateIcon,
} from '@radix-ui/react-icons';
import { useCallback, useState } from 'react';
import { Button } from '../ui/button';
import {
    Dialog,
    DialogClose,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from "../ui/dialog";
import { Label } from '../ui/label';
import { toast } from '../ui/use-toast';

import api from '../../lib/api';
import { DropdownMenuItem } from '../ui/dropdown-menu';
import { Textarea } from '../ui/textarea';

function DenyBunnyDialog({ bunny, fetchBunnies }) {
    const [isLoading, setIsLoading] = useState(false);
    const [reason, setReason] = useState('');

    const handleReasonChange = useCallback((e) => {
        setReason(e.target.value);
    }, []);

    const handleChange = async (e) => {
        e.preventDefault();
        if (isLoading) return;

        setIsLoading(true);
        const trimmedReason = reason.trim();

        try {
            const response = await api.post(`https://skhrf-api.cmdigital.se/v1/bunnies/deny`, {
                bunnyId: bunny.id,
                reason: trimmedReason,
            });
            fetchBunnies();
            toast({
                title: 'Kanin nekad',
                description: `${bunny.full_name} blev nekad med anledning ${trimmedReason}`,
            });
        } catch (error) {
            toast({
                variant: 'destructive',
                title: 'Något gick fel.',
                description: error?.response?.data?.error,
            });
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <Dialog>
            <DropdownMenuItem onSelect={(event) => event.preventDefault()}>
                <DialogTrigger className='flex items-center w-full'>
                    <Cross2Icon className='mr-3' />
                    Neka kanin
                </DialogTrigger>
            </DropdownMenuItem>
            <DialogContent
                className="flex flex-col gap-6" >
                <DialogHeader className='text-left'>
                    <DialogTitle>Neka kanin</DialogTitle>
                    <DialogDescription>Är du säker på att du vill neka {bunny.full_name}? Ansökande användare får ett e-postmeddelande om anledningen.</DialogDescription>
                </DialogHeader>
                <div className='flex flex-col gap-2 w-full'>
                    <Label htmlFor="reason">Anledning till nekande:</Label>
                    <Textarea
                        id='reason'
                        name='reason'
                        disabled={isLoading}
                        value={reason}
                        onChange={handleReasonChange}
                    />
                </div>
                <div className='grid grid-cols-2 gap-3'>
                    <DialogClose asChild>
                        <Button type='button' variant='secondary'>Avbryt</Button>
                    </DialogClose>
                    <Button type="submit" variant='destructive' onClick={handleChange} disabled={isLoading}>
                        {isLoading ? <UpdateIcon className='loader-spinner' /> : <>Neka {bunny.name}</>}
                    </Button>
                </div>
            </DialogContent>
        </Dialog>
    );
};

export default DenyBunnyDialog;
